export enum ContentPagesLabelsEnum {
  RELATED_SYMPTOMS = 'Relaterade besvär',
  RELATED_CARESERVICE_TYPES = 'Relaterade behandlingar',
}
